import { useCallback, useEffect, useState } from "react"

import useColors from "hooks/useColors"
import Color from "models/Color"
import { Guid } from "@/types"

export default function useAssetColor() {
    const [colorId, setColorId] = useState<Guid | null>(null)
    const [color, setColor] = useState<Color | null>(null)

    const {
        colors,
        fetchColors,
    } = useColors()

    const handleColorChange = useCallback(async (id: Guid | null) => {
        if (!id) {
            setColor(null)
            return
        }
        let currentColors = colors
        if (!currentColors) {
            currentColors = await fetchColors()
        }
        setColor(currentColors.find(c => c.id === id) || null)

    }, [colors, fetchColors])

    useEffect(() => {
        handleColorChange(colorId)
    }, [colorId, handleColorChange])

    const initColorById = useCallback((id?: Guid) => {
        setColorId(id || null)
    }, [])

    const initColorByName = useCallback(async (name?: string) => {
        if (name) {
            const newColorId = (await fetchColors()).find(c => {
                // find color name in any of translations
                return Object.entries(c.translations).some(([_, value]) => !!value && value.toLowerCase() === name.toLowerCase())
            })?.id || null
            setColorId(newColorId)
        } else {
            setColorId(null)
        }
    }, [fetchColors])

    return {
        color,
        initColorById,
        initColorByName,
        handleColorChange,
    }
}
